import { Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import FormInput from "../../../components/forms/form-Input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import { CUSTOMER_TYPES, CUSTOMER_STATUS } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";

export default function CustomerInformation({
  onNextStep,
  control,
  errors,
  handleSubmit,
}) {
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    clientId: {
      required: "Please Enter Client Id",
      validate: (value) => {
        if (value.toString().length > 100) return "Client Id is Too Long!";

        return true;
      },
    },
    name: {
      required: "Please Enter Name",
      validate: (value) => {
        if (value.length > 100) return "Name is Too Long!";

        return true;
      },
    },
    shortName: {
      required: "Please Enter Name",
      validate: (value) => {
        if (value.length > 100) return "Short Name is Too Long!";
        if (value.length < 3) return "Short Name is Too Short!";
        return true;
      },
    },
    customerType: {
      required: "Please Select Customer Type",
    },
    customerCode: {
      validate: (value) => {
        if (value.length > 50) return "Customer Code is Too Long!";
        return true;
      },
    },
  };

  return (
    <>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Customer Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            onClick={() => {}}
          >
            <Button onClick={handleSubmit(onNextStep)}>Next</Button>
          </Flex>
        </Flex>
      </Flex>

      <NumericInput
        {...generalFieldProps}
        isRequired
        inputProps={{ format: "#", className: "hide-spinners" }}
        label="Client Id"
        name="clientId"
        rules={formValidationRules.clientId}
        info="Numbers Only"
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Customer Name"
        name="name"
        rules={formValidationRules.name}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Short Name"
        name="shortName"
        info="Must Contain More Than 3 Characters"
        rules={formValidationRules.shortName}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Customer Type"
        name="customerType"
        id="id"
        text="text"
        data={CUSTOMER_TYPES || []}
        placeholder="Select Customer Type"
        rules={formValidationRules.customerType}
        dropdownProps={{ filterable: false }}
      />
      <FormInput
        {...generalFieldProps}
        label="Customer Code"
        name="customerCode"
        rules={formValidationRules.customerCode}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        id="id"
        text="text"
        data={CUSTOMER_STATUS || []}
        disablePlaceholderItem
        placeholder="Select Customer Status"
        dropdownProps={{ filterable: false }}
      />
      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="hasSeparateDispenseCount"
          rules={formValidationRules.hasSeparateDispenseCount || {}}
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Has Separate Dispense Count
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresEVhr"
          rules={formValidationRules.requiresEVhr || {}}
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
    </>
  );
}
